import { Suspense, lazy, useEffect, useLayoutEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import PreventBackNavigation from "./utils/PreventBackNavigation";
import { AppProvider } from "./Context/Context";
import { APIContext } from "./components/AdminPanel/APIContext/APIContext";
import "./App.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./components/PreOnboarding/onboardcss/onboard_style.css";
import "./components/PreOnboarding/onboardcss/onboard_responsive.css";
import "./components/PreOnboarding/onboardcss/onboard_animate.min.css";
// ⚡ Lazy Load Heavy Pages Only
const Home = lazy(() => import("./components/Home"));
const Admin = lazy(() => import("./components/AdminPanel/Admin"));
const PreOnboardingUserMaster = lazy(
  () => import("./components/PreOnboarding/PreOnboardingUserMaster"),
);
const AccountInfo = lazy(
  () =>
    import("./components/AdminPanel/Sales/Account/AccountInfoComponent/AccountInfo"),
);
const ErrorPage = lazy(() => import("./ErrorPage"));

// 🚀 Directly Import Lightweight Pages
import Login from "./Login/Login";
import ForgetPassword from "./Login/Forget/ForgetPassword";
import Protected from "./Login/Protected";
import LoaderTwo from "./utils/LoaderTwo";
import jwtDecode from "jwt-decode";
import { useAuthValidation } from "./utils/useAuthValidation";
import { baseUrl } from "../config";

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [shouldShowPreOnboarding, setShouldShowPreOnboarding] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const shouldValidate = baseUrl === "https://jarvis.work:8080/api/";
  useAuthValidation(setShouldShowPreOnboarding, setIsLoading, shouldValidate);
  // console.log("testing url");

  // ✅ One-time token sync on mount
  useLayoutEffect(() => {
    const storedToken = localStorage.getItem("token");

    try {
      if (storedToken) {
        sessionStorage.setItem("token", storedToken);
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  // ✅ Clean online/offline listener
  useEffect(() => {
    const handleOnlineStatusChange = () => setIsOnline(navigator.onLine);
    window.addEventListener("online", handleOnlineStatusChange);
    window.addEventListener("offline", handleOnlineStatusChange);
    return () => {
      window.removeEventListener("online", handleOnlineStatusChange);
      window.removeEventListener("offline", handleOnlineStatusChange);
    };
  }, []);

  // ✅ Global error catcher
  useEffect(() => {
    const handleGlobalError = (event) => {
      console.error("API Error:", event.detail);
      alert(event.detail);
    };
    window.addEventListener("globalApiError", handleGlobalError);
    return () => {
      window.removeEventListener("globalApiError", handleGlobalError);
    };
  }, []);

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");

    if (storedToken) {
      try {
        const decoded = jwtDecode(storedToken);
        if (decoded?.onboard_status === 2) {
          setShouldShowPreOnboarding(true);
        } else {
          setShouldShowPreOnboarding(false);
        }
      } catch (err) {
        console.error("Token decode failed:", err);
      }
    }
  }, []);

  if (isLoading) {
    return <LoaderTwo />;
  }
  return (
    <>
      <PreventBackNavigation />

      {/* Optional: show a banner if offline */}
      {!isOnline && (
        <div className="offline-banner">⚠ No Internet Connection</div>
      )}

      <Suspense fallback={<LoaderTwo />}>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forget-password" element={<ForgetPassword />} />

          {/* Protected Routes */}
          <Route path="/" element={<Protected />}>
            <Route
              index
              element={
                <AppProvider>
                  <Home />
                </AppProvider>
              }
            />
            {shouldShowPreOnboarding && (
              <Route
                path="/preonboard/pre-onboard-user-form"
                element={
                  <AppProvider>
                    <PreOnboardingUserMaster />
                  </AppProvider>
                }
              />
            )}
            {!shouldShowPreOnboarding && (
              <Route
                path="/admin/*"
                element={
                  // <Suspense fallback={<LoaderTwo />}>
                  <AppProvider>
                    <APIContext>
                      <Admin />
                    </APIContext>
                  </AppProvider>
                  // </Suspense>
                }
              />
            )}

            <Route
              path="/sales-account-info/:id"
              element={
                // <Suspense fallback={<Loader />}>
                <AppProvider>
                  <APIContext>
                    <AccountInfo />
                  </APIContext>
                </AppProvider>
                // </Suspense>S
              }
            />

            <Route
              path="*"
              element={
                <AppProvider>
                  <ErrorPage />
                </AppProvider>
              }
            />
          </Route>
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
